<template>
  <div class="container classroomDetail" style="min-height:35vw">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/classroom' }">农业课堂</el-breadcrumb-item>
      <el-breadcrumb-item>课堂详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="details-box">
      <div class="details-title">{{respData.title}}</div>
      <div class="details-info">
        <span>发布人：{{respData.publishByName}}</span>
        <span>{{respData.publishDate}}</span>
        <span>阅读量：{{respData.readingQuantity}}</span>
      </div>
      <div class="details-content">
        <video :autoplay="Autoplays" :src="$img +respData.videoUrl" controls></video>
        <div class="play" @click="playClick" v-if="play== true">
          <img src="../assets/play.png" />
        </div>
      </div>
      <p class="auto-c">{{respData.summary}}</p>
      <div class="details-next">
        <p @click="seeNext(Datas)">下一篇:{{Datas.title || '当前是最后一条啦'}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      respData: [],
      play: false,
      Autoplays: false,
      controls: "",
      Datas: ""
    };
  },
  mounted(e) {
    this.tid = this.$route.query.tid;
    let tid = this.tid;
    this.classPage(tid);
    this.NextClass(tid);
  },
  methods: {
    classPage(tid) {
      console.log(tid);
      let id = tid;
      this.$api.classroomApi
        .classDateil({ id })
        .then(res => {
          console.log("课堂详情=>", res);
          this.respData = res.data.respData;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    NextClass(tid) {
      let id = tid;
      this.$api.classroomApi
        .DateilNext({ id })
        .then(res => {
          console.log("下一条课堂详情=>", res);
          this.Datas = res.data.respData;
          this.Datas.respCode = res.data.respCode
          if (this.play == true) {
            this.respData = res.data.respData;
          }
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    // playClick(e) {
    //   this.play = !this.play
    //   this.Autoplays = true
    //     console.log(this);
    // },
    seeNext(Datas) {
      if (Datas.respCode == 0) {
        this.$message({
          message: "当前是最后一条了",
          type: "success"
        });
      } else {
        this.play = "true";
        let tid = Datas.tid;
        this.classPage(tid);
        this.NextClass(tid);
      }

      // this.play = false
    }
  }
};
</script>
<style lang="less" >
.classroomDetail{
  margin-top:20px;
}
.details-box {
  font-family: PingFangSC-Regular;
  width: 1200px;
  padding: 0 36px;
  margin: 20px auto 0;
  background: #ffffff;
  .details-title {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    font-size: 26px;
    color: #333333;
  }
  .details-info {
    height: 30px;
    width: 100%;
    background: #f6f6f6;
    line-height: 30px;
    text-align: center;
    margin-bottom: 15px;
    span {
      font-size: 14px;
      color: #999999;
      padding: 0 30px;
    }
  }
  .details-content {
    padding-bottom: 45px;
    display: -webkit-flex;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -o-justify-content: center;
    position: relative;
    video {
      width: 500px;
      height: 300px;
    }
    p {
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      line-height: 40px;
    }
    .play {
      width: 500px;
      height: 300px;
      position: absolute;
      top: 0px;
      left: auto;
      background: rgba(0, 0, 0, 0.11);
      display: -webkit-flex;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      -o-justify-content: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -o-align-items: center;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  .details-next {
    padding: 20px 0;
    border-top: 1px solid #e4e4e4;
    p {
      font-size: 18px;
      color: #5f5f5f;
      letter-spacing: 0;
      cursor: pointer;
    }
  }
}
.auto-c{
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
}
.el-breadcrumb__separator {
  color: #333;
}
</style>
<style>
  .el-breadcrumb {
    background-color: #fff;
    height: 35px;
    line-height: 35px !important;
    font-size: 16px;
    padding: 0 15px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/classroomDetail.vue